import React, {Component} from 'react';
import styles from './TagList.css';
import {TypeTagsList} from "../../constants/consts-prop-types"
import TagListItem from "../TagListItem/TagListItem"
import PropTypes from 'prop-types'

class TagList extends Component {
  static propTypes = {
    data: TypeTagsList,
    selectedTagId: PropTypes.string,
    onTagChange: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className={styles.TagList}>
        {this.props.data.map(tag => {
          return (
            <TagListItem
              key={tag.slug}
              data={tag}
              isSelected={this.props.selectedTagId === tag.slug}
              onToggle={this.props.onTagChange}
            />
          )
        })}
      </div>
    );
  }
}

export default TagList;



// WEBPACK FOOTER //
// ./src/components/TagList/TagList.js